import { resources, supportedLanguages } from './i18n';

export type PageSlug = 'about' | 'services' | 'portfolio' | 'contact' | 'price-form' | 'jotform-expert' | 'fillout-expert' | 'industry-real-estate' | 'industry-ecommerce' | 'industry-restaurants' | 'industry-financial' | 'industry-agencies' | 'industry-construction' | '10-reasons' | 'pricing-guide' | 'build-your-own' | 'interactive-lead-gen' | 'craftsmen-calculator' | 'b2b-lead-gen' | 'interactive-calculator' | 'calculator-examples' | 'calculator-mistakes';

// Get translated slug for a page in a specific language
export function getLocalizedSlug(page: PageSlug, lang: string): string {
  if (!supportedLanguages.includes(lang as any)) {
    lang = 'en';
  }
  
  return resources[lang as keyof typeof resources]?.common?.slugs?.[page] || page;
}

// Get page key from translated slug
export function getPageFromSlug(slug: string, lang: string): PageSlug | null {
  if (!supportedLanguages.includes(lang as any)) {
    lang = 'en';
  }
  
  const slugs = resources[lang as keyof typeof resources]?.common?.slugs;
  if (!slugs) return null;
  
  // Find the page key that matches this slug
  for (const [page, translatedSlug] of Object.entries(slugs)) {
    if (translatedSlug === slug) {
      return page as PageSlug;
    }
  }
  
  return null;
}

// Generate URL for a page in a specific language
export function generateLocalizedUrl(page: PageSlug, lang: string): string {
  const slug = getLocalizedSlug(page, lang);
  return `/${lang}/${slug}/`;
}

// Get equivalent URL when switching languages
export function getEquivalentUrl(currentPath: string, newLang: string): string {
  const pathParts = currentPath.split('/').filter(Boolean);
  
  if (pathParts.length === 0) {
    return `/${newLang}/`;
  }
  
  const [currentLang, ...slugParts] = pathParts;
  
  if (slugParts.length === 0) {
    return `/${newLang}/`;
  }
  
  const currentSlug = slugParts[0];
  const page = getPageFromSlug(currentSlug, currentLang);
  
  if (!page) {
    // Fallback to home if we can't determine the page
    return `/${newLang}/`;
  }
  
  return generateLocalizedUrl(page, newLang);
}